import { render } from "./ChartTemplate.vue?vue&type=template&id=bdd97b0a&scoped=true"
import script from "./ChartTemplate.vue?vue&type=script&lang=js"
export * from "./ChartTemplate.vue?vue&type=script&lang=js"

import "./ChartTemplate.vue?vue&type=style&index=0&id=bdd97b0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd97b0a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
